module.exports = __webpack_public_path__ + "static/media/newsireland.ed567557.png";